import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Header from './Header';

const ProfesorLayout: React.FC = () => {
  const { logout } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header 
        isAuthenticated={true} 
        userRole="profesor" 
        onLogout={logout}
      />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Routes>
          <Route path="/cursos" element={
            <div className="text-center py-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Mis Cursos</h2>
              <p className="text-gray-600">Funcionalidad en desarrollo</p>
            </div>
          } />
          <Route path="/notas" element={
            <div className="text-center py-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Cargar Notas</h2>
              <p className="text-gray-600">Funcionalidad en desarrollo</p>
            </div>
          } />
          <Route path="/" element={
            <div className="text-center py-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Panel de Profesor</h2>
              <p className="text-gray-600">Bienvenido al panel de profesor</p>
            </div>
          } />
        </Routes>
      </main>
    </div>
  );
};

export default ProfesorLayout;
